<template>
  <div>
    <b-modal
      ref="modal"
      id="modal-no-backdrop"
      hide-backdrop
      content-class="shadow"
      :title="'Confirma o cancelamento deste Documento?'"
    >
      <div class="container-fluid">
        <div class="row"></div>
        <br />
        <div class="row">
          <div class="col-12">
            <div>
              <template v-if="bills.person_id">
                <span>{{ bills.name }}</span
                ><span v-if="bills.description">
                  | {{ bills.description }}</span
                >
              </template>
              <template v-else>
                <span>{{ bills.description }}</span>
              </template>
              <br />
              <small class="text-muted">Documento: {{ bills.document }}</small>
              <br />
              <small class>Emitido em: {{ bills.issue_date | dateBr }}</small>
            </div>
          </div>
        </div>
        <br />
      </div>

      <div slot="modal-footer">
        <button
          role="button"
          class="btn btn-outline-secondary"
          @click="$refs.modal.hide()"
        >
          <i class="fas fa-times"></i> Não Cancelar
        </button>
        <button
          role="button"
          class="btn btn-danger"
          style="margin-left:5px"
          @click="store"
        >
          <i class="fas fa-check"></i> Cancelar
        </button>
      </div>
    </b-modal>
  </div>
</template>

<script>
  import Filters from "./../../../mixins/Filters";
  import Form from "./../../../mixins/Form";

  export default {
    data: function() {
      return {
        bills: {}
      };
    },
    methods: {
      open(bills) {
        this.bills = bills;
        this.$refs.modal.show();
      },

      store() {
        this.$store.commit("showLoading");
        this.$store
          .dispatch("billpayable/deleteBillPayable", this.bills.id)
          .then(response => {
            this.$store.commit("hideLoading");
            this.$emit("canceled");
            this.$refs.modal.hide();
          })
          .catch(error => {
            this.$store.commit("hideLoading");
            this.error = error;
          });
      }
    }
  };
</script>

<style>
</style>